import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-25" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4" }
const _hoisted_4 = { class: "position-relative table-src-form me-0" }
const _hoisted_5 = { class: "default-table-area all-products" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle" }
const _hoisted_8 = { scope: "col" }
const _hoisted_9 = {
  class: "form-check d-flex align-items-center",
  style: {"gap":"10px"}
}
const _hoisted_10 = { class: "text-body" }
const _hoisted_11 = {
  class: "form-check d-flex align-items-center",
  style: {"gap":"10px"}
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "position-relative top-2 text-secondary" }
const _hoisted_14 = {
  class: "d-flex align-items-center",
  style: {"gap":"12px"}
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "fw-semibold fs-14 text-secondary mb-0" }
const _hoisted_17 = { class: "text-secondary" }
const _hoisted_18 = { class: "text-secondary" }
const _hoisted_19 = { class: "text-body" }
const _hoisted_20 = { class: "text-secondary" }
const _hoisted_21 = { class: "d-flex align-items-center gap-1 justify-content-end" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap" }
const _hoisted_26 = { class: "fs-13" }
const _hoisted_27 = { "aria-label": "Page navigation example" }
const _hoisted_28 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_29 = { class: "page-item" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "page-item" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  class: "modal fade",
  id: "exampleModal2",
  tabindex: "-1",
  "aria-labelledby": "exampleModal2Label",
  "aria-hidden": "true"
}
const _hoisted_35 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"max-width":"550px"}
}
const _hoisted_36 = { class: "modal-content rounded-0" }
const _hoisted_37 = { class: "modal-header border-0 p-4 border-bottom" }
const _hoisted_38 = {
  class: "modal-title fs-18",
  id: "exampleModal2Label"
}
const _hoisted_39 = { class: "modal-body p-4" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-lg-6" }
const _hoisted_42 = { class: "form-group mb-4" }
const _hoisted_43 = { class: "col-lg-6" }
const _hoisted_44 = { class: "form-group mb-4" }
const _hoisted_45 = { class: "col-lg-6" }
const _hoisted_46 = { class: "form-group mb-4" }
const _hoisted_47 = { class: "col-lg-6" }
const _hoisted_48 = { class: "form-group mb-4" }
const _hoisted_49 = { class: "col-lg-6" }
const _hoisted_50 = { class: "form-group mb-4" }
const _hoisted_51 = { class: "col-lg-6" }
const _hoisted_52 = { class: "form-group mb-4" }
const _hoisted_53 = { class: "col-lg-12" }
const _hoisted_54 = { class: "form-group mb-4" }
const _hoisted_55 = { class: "col-lg-12" }
const _hoisted_56 = { class: "form-group mb-4 only-file-upload" }
const _hoisted_57 = { class: "form-control h-100 text-center position-relative p-4 p-lg-5" }
const _hoisted_58 = { class: "product-upload" }
const _hoisted_59 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_60 = ["src"]
const _hoisted_61 = { class: "col-lg-12" }
const _hoisted_62 = { class: "d-flex justify-content-end flex-wrap gap-3" }
const _hoisted_63 = {
  type: "submit",
  class: "btn btn-primary py-2 px-4 fw-medium fs-16",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control border-0",
            placeholder: "Search here....",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterGuests && _ctx.filterGuests(...args)))
          }, null, 544), [
            [_vModelText, _ctx.searchQuery]
          ]),
          _cache[19] || (_cache[19] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y text-secondary" }, " search ", -1))
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-primary fw-medium rounded-3 hover-bg",
          "data-bs-toggle": "modal",
          "data-bs-target": "#exampleModal2",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openAddModal && _ctx.openAddModal(...args)))
        }, [...(_cache[20] || (_cache[20] = [
          _createElementVNode("span", {
            class: "d-flex align-items-center",
            style: {"gap":"5px"}
          }, [
            _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block fs-20 lh-1" }),
            _createElementVNode("span", null, "Add New Room")
          ], -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input position-relative top-1",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectAll) = $event)),
                      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.selectAll]
                    ]),
                    _cache[21] || (_cache[21] = _createElementVNode("label", { class: "position-relative fs-14" }, "Code", -1))
                  ])
                ]),
                _cache[22] || (_cache[22] = _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14" }, "Guest Name")
                ], -1)),
                _cache[23] || (_cache[23] = _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14" }, "Check In")
                ], -1)),
                _cache[24] || (_cache[24] = _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14" }, "Check Out")
                ], -1)),
                _cache[25] || (_cache[25] = _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14" }, "Room")
                ], -1)),
                _cache[26] || (_cache[26] = _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14" }, "Total Bill")
                ], -1)),
                _cache[27] || (_cache[27] = _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14" }, "Payment Status")
                ], -1)),
                _cache[28] || (_cache[28] = _createElementVNode("th", {
                  scope: "col",
                  class: "text-end"
                }, "Action", -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedGuests, (guest) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: guest.id
                }, [
                  _createElementVNode("td", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedGuests) = $event)),
                        value: guest.id
                      }, null, 8, _hoisted_12), [
                        [_vModelCheckbox, _ctx.selectedGuests]
                      ]),
                      _createElementVNode("label", _hoisted_13, " #" + _toDisplayString(guest.id.toString().padStart(3, "0")), 1)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("img", {
                        src: guest.avatar,
                        class: "rounded-circle wh-40",
                        alt: "user"
                      }, null, 8, _hoisted_15),
                      _createElementVNode("h6", _hoisted_16, _toDisplayString(guest.name), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.formatDate(guest.checkIn)), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.formatDate(guest.checkOut)), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(guest.room), 1),
                  _createElementVNode("td", _hoisted_20, " $" + _toDisplayString(guest.totalBill.toFixed(2)), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["d-inline-block border px-2 rounded-pill fs-12 fw-medium", _ctx.getStatusClass(guest.paymentStatus)])
                    }, _toDisplayString(guest.paymentStatus), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("button", {
                        class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                        onClick: ($event: any) => (_ctx.viewGuest(guest.id))
                      }, [...(_cache[29] || (_cache[29] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ", -1)
                      ]))], 8, _hoisted_22),
                      _createElementVNode("button", {
                        class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#exampleModal2",
                        onClick: ($event: any) => (_ctx.editGuest(guest.id))
                      }, [...(_cache[30] || (_cache[30] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " edit ", -1)
                      ]))], 8, _hoisted_23),
                      _createElementVNode("button", {
                        class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                        onClick: ($event: any) => (_ctx.deleteGuest(guest.id))
                      }, [...(_cache[31] || (_cache[31] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ", -1)
                      ]))], 8, _hoisted_24)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("span", _hoisted_26, " Showing " + _toDisplayString(_ctx.paginatedGuests.length) + " of " + _toDisplayString(_ctx.filteredGuests.length) + " Results ", 1),
          _createElementVNode("nav", _hoisted_27, [
            _createElementVNode("ul", _hoisted_28, [
              _createElementVNode("li", _hoisted_29, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Previous",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.currentPage === 1
                }, [...(_cache[32] || (_cache[32] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))], 8, _hoisted_30)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: page === _ctx.currentPage }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_31)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_32, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Next",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, [...(_cache[33] || (_cache[33] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))], 8, _hoisted_33)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("h1", _hoisted_38, _toDisplayString(_ctx.isEditing ? "Edit Guest" : "Add New Guest"), 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close campaigns-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
              })
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("form", {
                onSubmit: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _cache[34] || (_cache[34] = _createElementVNode("label", { class: "label text-secondary" }, "Code", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control h-60 border-border-color",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.code) = $event)),
                        placeholder: "#001"
                      }, null, 512), [
                        [_vModelText, _ctx.formData.code]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _cache[35] || (_cache[35] = _createElementVNode("label", { class: "label text-secondary" }, "Guest Name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control h-60 border-border-color",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.name) = $event)),
                        placeholder: "John Doe",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.formData.name]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _cache[36] || (_cache[36] = _createElementVNode("label", { class: "label text-secondary" }, "Check In", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: "form-control h-60 border-border-color",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.checkIn) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.formData.checkIn]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _cache[37] || (_cache[37] = _createElementVNode("label", { class: "label text-secondary" }, "Check Out", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: "form-control h-60 border-border-color",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.checkOut) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.formData.checkOut]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _cache[38] || (_cache[38] = _createElementVNode("label", { class: "label text-secondary" }, "Room", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control h-60 border-border-color",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.room) = $event)),
                        placeholder: "GO-12",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.formData.room]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _cache[39] || (_cache[39] = _createElementVNode("label", { class: "label text-secondary" }, "Total Bill", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control h-60 border-border-color",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.totalBill) = $event)),
                        placeholder: "250.00",
                        step: "0.01",
                        min: "0",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.formData.totalBill]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _cache[41] || (_cache[41] = _createElementVNode("label", { class: "label text-secondary" }, "Payment Status", -1)),
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select form-control h-60",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.paymentStatus) = $event)),
                        required: ""
                      }, [...(_cache[40] || (_cache[40] = [
                        _createElementVNode("option", { value: "Completed" }, "Completed", -1),
                        _createElementVNode("option", { value: "Pending" }, "Pending", -1),
                        _createElementVNode("option", { value: "Failed" }, "Failed", -1)
                      ]))], 512), [
                        [_vModelSelect, _ctx.formData.paymentStatus]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _cache[43] || (_cache[43] = _createElementVNode("label", { class: "label text-secondary" }, "Avatar", -1)),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _cache[42] || (_cache[42] = _createElementVNode("label", {
                            for: "file-upload",
                            class: "file-upload mb-0"
                          }, [
                            _createElementVNode("i", { class: "ri-folder-image-line bg-primary bg-opacity-10 p-2 rounded-1 text-primary" }),
                            _createElementVNode("span", { class: "d-block text-body fs-14" }, [
                              _createTextVNode(" Drag and drop an image or "),
                              _createElementVNode("span", { class: "text-primary text-decoration-underline" }, " Browse ")
                            ])
                          ], -1)),
                          _createElementVNode("input", {
                            id: "file-upload",
                            class: "form__file bottom-0",
                            type: "file",
                            onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                            accept: "image/*"
                          }, null, 32)
                        ])
                      ]),
                      (_ctx.formData.avatarPreview)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _createElementVNode("img", {
                              src: _ctx.formData.avatarPreview,
                              class: "rounded-circle wh-40",
                              alt: "Preview"
                            }, null, 8, _hoisted_60)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger py-2 px-4 fw-medium fs-16 text-white",
                        "data-bs-dismiss": "modal",
                        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                      }, " Cancel "),
                      _createElementVNode("button", _hoisted_63, [
                        _cache[44] || (_cache[44] = _createElementVNode("i", { class: "ri-add-line text-white fw-medium" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? "Update" : "Create"), 1)
                      ])
                    ])
                  ])
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ]))
}